<template>
  <Modal :id="'cmp-add-country'" @cancelled="onCancel">
    <template slot="header"> {{$t('add_country')}} </template>

    <template slot="body">
      <div class="form-group">
        <Dropdown
          class="dt-dropdown m2"
          :options="countries.map(x => ({text: x, value:x}))"
          :selected="selectedCountry"
          box
          :placeholder="$t('country')"
          v-on:selectedChange="e => onDropdownChange('country', e)"
          :listHeight="150"
        ></Dropdown>

        <TextField
          class="m1"
          :id="'notes'"
          textarea
          :height="80"
          v-bind="textFieldConfig"
          v-model="notes"
          isModel
          :placeholder="$t('source')"
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onAddCountry">{{$t('add_new')}}</button>
    </template>
  </Modal>
</template>

<script>
import { ArtistService } from "../../../services/artists";
import Modal from "../../../../../dt-plugins/modal/modal";

export default {
  components: {
    Modal
  },
  props: {},
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      notes: "",
      countries: [],
      selectedCountry: null
      // Mark: Data
    };
  },
  mounted: function() {
    ArtistService.findCountries({
      artistId: this.artistId
    }).then(res => {
      // console.log(res.data);
      this.countries = res.data.countries;
    });
  },
  watch: {},
  computed: {
    artistId: function() {
      return this.$route.query.artist_id;
    }
  },
  methods: {
    onAddCountry: function(event) {
      console.log({
        artistId: this.artistId,
        country: this.selectedCountry.value,
        notes: this.notes
      });

      ArtistService.insertCountry({
        artistId: this.artistId,
        country: this.selectedCountry.value,
        notes: this.notes
      }).then(res => {
        this.$emit("added", res);
      });
    },
    onCancel: function(event) {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function(name, value) {
      this.selectedCountry = value;
    }
    // Mark: Methods
  }
};

const createcountry = ({ country = "", artist_country_id = 0, notes = "" }) => {
  return {
    country,
    artist_country_id,
    notes
  };
};
</script>

<style lang="scss" scoped>
// .ckeditor-container {
//   .ck-editor {
//     width: 100%;
//   }

// }
</style>
